// Querystring override for choosing the quiz experience in prod while the
// `ultra-experience` flag is off (mirrors the email-popup force pattern).
// `?quizVariant=<name>` forces the embedded fi-quizz widget with that design
// variant, `?quizVariant=legacy` forces the legacy in-app quiz, and
// `?forceShowQuiz` (truthy) is shorthand for the default widget variant. The
// override bypasses the flag entirely, so it also works for logged-out traffic.
export const QUIZ_VARIANT_PARAM = 'quizVariant';
export const FORCE_SHOW_QUIZ_PARAM = 'forceShowQuiz';

// Reserved override value that forces the legacy in-app quiz instead of the widget.
export const LEGACY_VARIANT = 'legacy';
// Default fi-quizz design variant when none is named (flag path / forceShowQuiz).
export const DEFAULT_QUIZ_VARIANT = 'new';
// Reserved override value that forces the in-app hardware-first quiz sheet.
export const HARDWARE_FIRST_VARIANT = 'hardware-first';

const FALSEY_VALUES = new Set(['false', '0', 'no', 'off']);

/**
 * Parses the quiz-variant override out of a URL query string (e.g.
 * `window.location.search`). Returns the normalized variant name (a widget
 * design name, or `'legacy'` to force the in-app quiz), or `undefined` when no
 * recognized override is present. An explicit `quizVariant` value wins over
 * `forceShowQuiz` (shorthand for the default widget variant).
 */
export function parseQuizVariantOverride(search: string): string | undefined {
  const params = new URLSearchParams(search);

  const explicit = params.get(QUIZ_VARIANT_PARAM)?.trim().toLowerCase();
  if (explicit) {
    return explicit;
  }

  const forceShow = params.get(FORCE_SHOW_QUIZ_PARAM);
  if (forceShow !== null && !FALSEY_VALUES.has(forceShow.trim().toLowerCase())) {
    return DEFAULT_QUIZ_VARIANT;
  }

  return undefined;
}
